import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from 'src/app/shared/http/json-http.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SchedulerTaskContainer, SchedulerTaskHandler, SchedulerTaskPresentation } from '../models/scheduler-task-objects';
import { DataFieldGroup } from 'src/app/shared/datafields/models';
import { SchedulerLog } from '../models/scheduler-log';

@Injectable({
    providedIn: 'root'
})
export class SchedulerTaskService {

    constructor(private http: JsonHttpService) {
    }
    getSchedulerTaskPresentation(id?: number): Promise<SchedulerTaskPresentation> {
        const options = { params: new HttpParams() };
        if (id) {
            options.params = options.params.append('id', id.toString());
        }
        return this.http.getTyped<SchedulerTaskPresentation>('/api/scheduler/get-scheduler-presentation', options).toPromise();
    }

    getSchedulerTaskDataFieldGroups(artifactId: string, schedulerTaskId: number | null): Promise<DataFieldGroup[]> {
        const options = { params: new HttpParams().set('artifactId', artifactId) };
        if (schedulerTaskId) {
            options.params = options.params.set('schedulerTaskId', schedulerTaskId);
        }
        return this.http.get('/api/scheduler/get-datafield-groups', options).toPromise();
    }

    getSchedulerTaskPresentations(id?: number): Promise<SchedulerTaskPresentation[]> {
        return this.http.getTyped<SchedulerTaskPresentation[]>('/api/scheduler/get-scheduler-presentations').pipe(
            map(items => items.map(item => new SchedulerTaskPresentation(item))) // Convert to actual object instances
        ).toPromise();
    }

    deleteSchedulerTask(id: number): Promise<number> {
        const options = { params: new HttpParams().set('schedulerTaskId', id.toString()) };
        return this.http.delete('/api/scheduler/delete-scheduler', options).toPromise();
    }

    saveSchedulerTask(item: SchedulerTaskContainer): Promise<SchedulerTaskPresentation> {
        return this.http.post('/api/scheduler/save-scheduler', item).toPromise();
    }

    isSchedulerNameAvailable(schedulerTaskName: string, ignoreSchedulerTaskId?: number): Promise<boolean> {
        const options = { params: new HttpParams().set('schedulerTaskName', `${schedulerTaskName}`) };

        if (ignoreSchedulerTaskId) {
            options.params = options.params.set('ignoreSchedulerTaskId', `${ignoreSchedulerTaskId}`);
        }
        return this.http.get('/api/scheduler/is-scheduler-name-available', options).toPromise();
    }

    GetLoggedSchedulers(schedulerTaskId: number): Observable<SchedulerLog[]> {
        const options = { params: new HttpParams().set('schedulerTaskId', `${schedulerTaskId}`) };
        return this.http.getTyped<SchedulerLog[]>('/api/scheduler/get-logged-schedules', options).pipe(
            map(result => result.map(item => {
                item.StartDate = new Date(item.StartDate);
                item.EndDate = new Date(item.EndDate);
                item.Duration = (item.EndDate.getTime() - item.StartDate.getTime()) / 1000;
                return item;
            }))
        );
    }

    GetLog(logId: number): Observable<SchedulerLog> {
        const options = { params: new HttpParams().set('logId', `${logId}`) };
        return this.http.getTyped<SchedulerLog>('/api/scheduler/get-scheduler-log', options).pipe(
            map(result => {
                result.StartDate = new Date(result.StartDate);
                result.EndDate = new Date(result.EndDate);
                result.Duration = (result.EndDate.getTime() - result.StartDate.getTime()) / 1000;
                return result;
            })
        );
    }

    async getSchedulerTaskHandlers(): Promise<SchedulerTaskHandler[]>{
        return await this.http.get('/api/scheduler/get-scheduler-handlers').toPromise();
    }
}
